import type { FC } from "react";

import type { LegalDocumentKey } from "@/features/legal/legalTexts.ts";
import { preloadLegalDocument } from "@/features/legal/LegalDocumentOverlay.tsx";

interface LegalDocumentTriggerProps {
	doc: LegalDocumentKey;
	label: string;
	onOpen: (doc: LegalDocumentKey) => void;
}

/**
 * The inline link that opens a legal document.
 *
 * A button rather than an anchor: there is no document to navigate to, and the previous
 * `href="#"` pushed a fragment onto the registration URL. `type="button"` is not optional —
 * this sits inside the step's <form>, where a button would otherwise default to submitting it.
 */
export const LegalDocumentTrigger: FC<LegalDocumentTriggerProps> = ({ doc, label, onOpen }) => {
	return (
		<button
			type="button"
			// align-baseline keeps it on the sentence's baseline; cursor-pointer is needed
			// because Tailwind v4's preflight no longer sets it on buttons.
			className="text-brand-primary-900 cursor-pointer align-baseline font-medium hover:underline"
			onClick={() => onOpen(doc)}
			onPointerEnter={preloadLegalDocument}
			onFocus={preloadLegalDocument}
		>
			{label}
		</button>
	);
};
